import type { RouteProps } from '../../util';
import { CheckoutCompletePage } from '../components';


export const CheckoutCompleteRoute = (_: RouteProps) => <CheckoutCompletePage/>;